'use client';

import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlay } from '@awesome.me/kit-94e593bf23/icons/sharp/solid';

/**
 * Video preview button for the product carousel.
 *
 * Pure UI: thumbnail + play overlay. Playback happens in VideoModal — this
 * component just calls `onPlay` when clicked. Sizing is owned by the parent
 * slide wrapper so the video slide matches the image slides around it.
 */
const VideoSlide = t0 => {
  const $ = _c(10);
  const {
    video,
    productName,
    onPlay
  } = t0;
  let t1;
  if ($[0] !== onPlay) {
    t1 = e => {
      e.stopPropagation();
      if (onPlay) {
        onPlay();
      }
    };
    $[0] = onPlay;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleClick = t1;
  const t2 = `Play ${productName} video`;
  const t3 = `${productName} video`;
  let t4;
  if ($[2] !== t3 || $[3] !== video.thumbnail) {
    t4 = <Image className="w-full h-full object-contain" src={video.thumbnail} alt={t3} fill={true} sizes="(max-width: 767px) calc(100vw - 40px), (max-width: 1023px) calc(100vw - 48px), (max-width: 1279px) calc(100vw - 448px), (max-width: 1535px) calc(100vw - 488px), calc(100vw - 508px)" quality={75} />;
    $[2] = t3;
    $[3] = video.thumbnail;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="absolute inset-0 flex items-center justify-center"><div className="w-20 h-20 rounded-full bg-black/60 flex items-center justify-center group-hover:bg-primary/90 transition-colors duration-300"><FontAwesomeIcon icon={faPlay} className="text-white text-2xl ml-1" /></div></div>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== handleClick || $[7] !== t2 || $[8] !== t4) {
    t6 = <button type="button" onClick={handleClick} className="relative w-full h-full cursor-pointer group" aria-label={t2}>{t4}{t5}</button>;
    $[6] = handleClick;
    $[7] = t2;
    $[8] = t4;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t6;
};
export default VideoSlide;